import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpClient,
    private config: ConfigService) { }

  existUser(data: object) {
    const requestOptions: object = {
      headers: new Headers().set('responseType', 'text')
    }
    const url = this.config.urlService + "api/Ingreso/user";
    return this.http.post(url, data, requestOptions);
  }

  credentials(data: object) {
    const url = this.config.urlService + "api/Ingreso";
    return this.http.post(url, data);
  }

  rememberPwd(data: object){
    const requestOptions: object = {
      headers: new Headers().set('responseType', 'text')
    }
    const url = this.config.urlService + "api/Ingreso/Email";
    return this.http.post(url, data, requestOptions);
  }

  parametrizacion = (token: string, idProveedor: number) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Ingreso/Parametrizacion/"+ idProveedor;
    return this.http.get(url, requestOptions);
  }
}
